export const validationMessages = {
  required: (fieldName) =>
    `${
      fieldName?.charAt(0).toUpperCase() + fieldName?.slice(1).toLowerCase()
    } is required.`,
  format: (fieldName) => ` ${fieldName} should be in correct format.`,
  text: (fieldName) => `${fieldName} should be text`,
  passwordLength: (fieldName, minLength) =>
    `${fieldName} should be at least ${minLength} characters.`,
  characterLength: (fieldName, minLength) =>
    `${fieldName} should be ${minLength} characters.`,
  contactLength: (fieldName, minLength) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } should be ${minLength} digit.`,
  passwordComplexity: (fieldName) =>
    `${fieldName} must include eight characters, uppercase letter, lowercase letter, one number and one special character`,
  passwordsMatch: (fieldName, confirmFieldName) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } and ${confirmFieldName.toLowerCase()} should be same.`,
  passwordsNotMatch: (fieldName, confirmFieldName) =>
    `${
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1).toLowerCase()
    } and ${confirmFieldName.toLowerCase()} should not be same.`,
  phoneNumber: (fieldName) => `Invalid ${fieldName.toLowerCase()} format.`,
  notSameAsField: (fieldName, comparedField) =>
    `${fieldName} should be different from ${comparedField}.`,
  maxLength: (fieldName, maxLength) =>
    `${fieldName} should be at ${maxLength} characters.`,
  minLength: (fieldName, minLength) =>
    `${fieldName} should be minimum ${minLength} characters.`,
  positiveNumber: (fieldName) => `${fieldName} should be positive`,
  url: (field) => `${field} should be a valid URL`,
  greaterThan: (fieldName, comparedField) =>
    `${comparedField} should be greater than or equal to ${fieldName}.`,
  greaterTime: (fieldName, comparedField) =>
    `${comparedField} should be greater than ${fieldName}.`,
};

export const InputPlaceHolder = (fieldName) => {
  return `Enter ${fieldName?.toLowerCase()}`;
};

export const SelectPlaceHolder = (fieldName) => {
  return `Select ${fieldName?.toLowerCase()}`;
};

export const RequiredField = (field) => {
  return `${field} is required.`;
};
export const BasicPlaceholderFormat = (fieldName) => {
  return ` Please enter your ${fieldName}`;
};
export const phoneRegex = /^\d{10}$/;
export const numberRegex = /^(?=.*\d)[\d\s]+$/;
export const aadharRegex = /^(?=.*\d)[\d\s]+$/ || "^[2-9]{1}[0-9]{11}$";
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}(?![^.\s])/;
export const digitRegex = /^\d*$/;
export const zipcodeRegex = /^\d{6}$/;

// ^ represents the starting of the string.
// [2-9]{1} represents the first digit should be any from 2-9.
// [0-9]{3} represents the next 3 digits after the first digit should be any digit from 0-9.
// \\s represents white space.
// [0-9]{4} represents the next 4 digits should be any from 0-9.
// \\s represents white space.
// [0-9]{4} represents the next 4 digits should be any from 0-9.
// $ represents the ending of the string.
